/* Swiper
 **************************************************************/
var swiper = Swiper;
var init = false;
document.addEventListener("DOMContentLoaded", function () {
  const featuredArticlesCarousel = document.querySelector(
    ".featured-articles__cards-wrapper"
  );

  if (featuredArticlesCarousel) {
    const displayValue = getComputedStyle(
      featuredArticlesCarousel,
      null
    ).display;

    if (displayValue == "block") {
      /* Which media query
       **************************************************************/
      function swiperMode() {
        let mobile = window.matchMedia(
          "(min-width: 0px) and (max-width: 767.98px)"
        );
        let aboveMobile = window.matchMedia("(min-width: 768px)");

        // Enable (for mobile)
        if (mobile.matches) {
          if (!init) {
            init = true;
            swiper = new Swiper(".featured-articles__cards-wrapper", {
              direction: "horizontal",
              loop: true,
              effect: "slide",
              speed: 1000,
              keyboard: true,
              centeredSlides: true,
              slidesPerView: 1.7,
              spaceBetween: 16,
              grabCursor: false,
              breakpoints: {
                695: {
                  slidesPerView: 2.5,
                },
                565: {
                  slidesPerView: 2.1,
                },
                520: {
                  slidesPerView: 2,
                },
                440: {
                  slidesPerView: 1.75,
                },
              },

              // If we need pagination
              pagination: {
                el: ".swiper-pagination",
              },

              // Navigation arrows
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
            });
          }
          // Disable (for aboveMobile)
        } else if (aboveMobile.matches) {
          if (swiper.destroy) {
            swiper.destroy();
            init = false;
          }
        }
      }

      /* On Load
       **************************************************************/
      swiperMode();

      /* On Resize
       **************************************************************/
      window.addEventListener(
        "resize",
        debounce(function () {
          swiperMode();
        }, 250)
      );
    }
  }
});
